import React, { useContext } from "react"
import { Div, Text } from "atomize"
import { motion } from "framer-motion"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faBookOpen, faChevronRight } from "@fortawesome/free-solid-svg-icons"
import Card from "../atoms/Card"
import { modalContext } from "../providers/modal.provider"
import { theme } from "../settings/config"
import { GUIDE_TOPICS } from "../help/guide"

// La guida nel profilo: gli argomenti che servono di più, e tutti gli altri
// a un tocco, con la ricerca (src/modals/GuideModal.js). I testi stanno in
// src/help/guide.js. Dentro la scheda bianca ogni argomento è un blocco sul
// fondo caldo, senza bordi, come gli altri blocchi dell'app.
function GuideCard() {
	const Modal = useContext(modalContext)
	const featured = GUIDE_TOPICS.filter(topic => topic.featured)

	return (
		<Card bg={theme.colors.surface}>
			<Div d="flex" align="center" style={{ gap: "0.5rem" }} m={{ b: "1rem" }}>
				<Div
					w="40px"
					h="40px"
					rounded="circle"
					bg={theme.colors.gunmetal_lighter}
					d="flex"
					align="center"
					justify="center"
					style={{ flexShrink: 0 }}>
					<FontAwesomeIcon icon={faBookOpen} color={theme.colors.gunmetal} />
				</Div>
				<Div>
					<Text textWeight="bold" textSize="title" style={{ lineHeight: 1.2 }}>
						Guida
					</Text>
					<Text textSize="caption" textColor={theme.colors.text_light}>
						Come si fanno le cose di tutti i giorni
					</Text>
				</Div>
			</Div>

			<Div d="flex" flexDir="column" style={{ gap: "0.5rem" }}>
				{featured.map(topic => (
					<motion.div key={topic.id} whileTap={{ scale: 0.99 }}>
						<Div
							tag="button"
							w="100%"
							bg={theme.colors.background}
							rounded="15px"
							p="0.75rem 1rem"
							d="flex"
							align="center"
							cursor="pointer"
							textAlign="left"
							textSize="body"
							textColor={theme.colors.gunmetal}
							style={{ gap: "0.75rem", border: 0, fontFamily: "inherit" }}
							onClick={() => Modal.open("guide", { topicID: topic.id })}>
							<Div flexGrow="1">
								<Text textWeight="500">{topic.title}</Text>
								<Text textSize="caption" textColor={theme.colors.text_light}>
									{topic.hint}
								</Text>
							</Div>
							<FontAwesomeIcon
								icon={faChevronRight}
								color={theme.colors.text_light}
								size="sm"
							/>
						</Div>
					</motion.div>
				))}
			</Div>

			<Div d="flex" justify="center" m={{ t: "0.75rem" }}>
				<Text
					tag="button"
					bg="transparent"
					p="0.25rem 0.5rem"
					textSize="body"
					textWeight="500"
					textColor={theme.colors.primary}
					cursor="pointer"
					style={{ border: 0, fontFamily: "inherit" }}
					onClick={() => Modal.open("guide", {})}>
					{`Tutti gli argomenti (${GUIDE_TOPICS.length})`}
				</Text>
			</Div>
		</Card>
	)
}

export default GuideCard
